import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouter, useTranslate } from "@bluelibs/x-ui";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import * as Ant from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
import { ApolloError, useLazyQuery } from "@apollo/client";
import { AdminListItemRenderer } from "@bluelibs/x-ui-admin/dist/react/components";
import { Routes } from "@bundles/UIAppBundle";
import { FindCompanyBankBalances } from "@bundles/UIAppBundle/queries/FindCompanyBankBalances";
const ListCompanyBankBalances = forwardRef(({ companyIds, bankAccountIds }, ref) => {
    const t = useTranslate();
    const router = useRouter();
    const [datas, setDatas] = useState([]);
    const [fetchData] = useLazyQuery(FindCompanyBankBalances, {
        variables: {
            input: {
                companyIds,
                bankAccountIds,
            },
        },
    });
    const fetchDatas = () => {
        fetchData({ variables: { input: { companyIds, bankAccountIds } } })
            .then((res) => {
            setDatas(res.data.FindCompanyBankBalances);
        })
            .catch((err) => {
            if (err instanceof ApolloError) {
                const errMessage = err.message.toLowerCase().split(" ").join("_");
                const i18nMessage = t(`apiErrors.${errMessage}`);
                Ant.notification.warn({
                    message: i18nMessage.length > 0 ? i18nMessage : t("generics.error"),
                });
            }
            else {
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: t("generics.error_message"),
                });
            }
        });
    };
    useImperativeHandle(ref, () => ({
        refetchData() {
            fetchDatas();
        },
    }));
    useEffect(() => {
        fetchDatas();
    }, [companyIds, bankAccountIds]);
    const columns = [
        {
            id: "external",
            title: t("management.transactions.fields.company"),
            key: "companyName",
            width: 300,
            render: (value, model) => {
                const props = {
                    type: "relation",
                    value,
                    relation: {
                        path: router.path(Routes.COMPANIES_VIEW, {
                            params: {
                                id: value === null || value === void 0 ? void 0 : value.companyId,
                            },
                        }),
                        dataIndex: "companyName",
                    },
                };
                return _jsx(AdminListItemRenderer, Object.assign({}, props), void 0);
            },
        },
        {
            id: "dueDate",
            title: t("management.transactions.fields.bank"),
            key: "bankName",
            width: 400,
            render: (value, model) => {
                const props = {
                    type: "relation",
                    value,
                    relation: {
                        path: router.path(Routes.BANKS_VIEW, {
                            params: {
                                id: value === null || value === void 0 ? void 0 : value.bankId,
                            },
                        }),
                        dataIndex: "bankName",
                    },
                };
                return _jsx(AdminListItemRenderer, Object.assign({}, props), void 0);
            },
        },
        {
            id: "dueDate",
            title: t("management.transactions.fields.totalBalance"),
            key: "totalBalance",
            width: 400,
            render: (value, model) => {
                var _a;
                const props = {
                    type: "number",
                    value: `${((_a = value === null || value === void 0 ? void 0 : value.totalBalance) !== null && _a !== void 0 ? _a : 0).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })} ${model === null || model === void 0 ? void 0 : model.currency}`,
                };
                return _jsx(AdminListItemRenderer, Object.assign({}, props), void 0);
            },
        },
    ];
    return (_jsxs(Ant.Card, Object.assign({ className: "total-balances-container-table" }, { children: [_jsx("p", Object.assign({ className: "total-balances-container-table-header" }, { children: t("management.transactions.list.total_bank_balances") }), void 0), _jsx(Ant.Layout.Content, { children: _jsx(Ant.Table, { pagination: {
                        total: datas.length,
                        position: ["bottomLeft"],
                    }, columns: columns, dataSource: datas }, void 0) }, void 0)] }), void 0));
});
export default ListCompanyBankBalances;
